// dawid-front/src/app/engine/events.js
export const EVENT_ATTRIBUTE_CHANGED = 'attributeChanged';
export const EVENT_ITEM_CHANGED = 'itemChanged';
export const EVENT_LOOP_UPDATED = 'loopUpdated';
export const EVENT_PATH_UPDATED = 'pathUpdated';
export const EVENT_FLOW_CHANGED = 'flowChanged';
export const EVENT_VALIDATION_CHANGED = 'validationChanged';
export const EVENT_ERROR_RAISED = 'errorRaised';
